import axiosInstance from "./axiosConfig";
import { handleApiError } from "./errorHandler";

export const get_Customer_Partner_Details = async ({customerid}) => {
    try {
        console.log(customerid);
        const response = await axiosInstance.get(`/api/get_customer_partner_details?customerid=${customerid}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'get_Customer_Partner_Details');
    }
};

export const add_partner_details_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/add_partner_details`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'add_partner_details_api');
    }
};

export const edit_partner_details_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/edit_partner_details`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'edit_partner_details_api');
    }
};

export const delete_partner_details_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/delete_partner_details`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'delete_partner_details_api');
    }
};

export const check_partner_access_api = async (userEmail) => {
    try {
        console.log("useremail", userEmail);
        const response = await axiosInstance.get(`/api/check_partner_access?useremail=${userEmail}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'check_partner_access_api');
    }
};

export const getCustomerPartner_api = async (customerid, userEmail) => {
    try {
        console.log("customerid", customerid);
        console.log("useremail", userEmail);
        const response = await axiosInstance.get(`/api/get_customer_partner?customerid=${customerid}&useremail=${userEmail}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'getCustomerPartner_api');
    }
};

export const logout_partner_access = async (data) => {
    try {
        console.log("data", data);
        const response = await axiosInstance.post(`/api/logout_partner_access`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'logout_partner_access');
    }
};
